let audioContext: AudioContext | null = null

function getAudioContext(): AudioContext {
  if (!audioContext) {
    audioContext = new (window.AudioContext ||
      (window as any).webkitAudioContext)()
  }
  return audioContext
}

// Short notification chime — bright and attention-grabbing
export function playNotificationSound() {
  try {
    const ctx = getAudioContext()
    const now = ctx.currentTime

    // Three-tone ascending chime
    const tones = [
      { freq: 880, start: 0, duration: 0.15 },
      { freq: 1100, start: 0.15, duration: 0.15 },
      { freq: 1320, start: 0.3, duration: 0.25 },
    ]

    tones.forEach(({ freq, start, duration }) => {
      const osc = ctx.createOscillator()
      const gain = ctx.createGain()
      osc.connect(gain)
      gain.connect(ctx.destination)
      osc.type = 'sine'
      osc.frequency.setValueAtTime(freq, now + start)
      gain.gain.setValueAtTime(0.4, now + start)
      gain.gain.exponentialRampToValueAtTime(0.001, now + start + duration)
      osc.start(now + start)
      osc.stop(now + start + duration + 0.05)
    })

    // Vibrate if supported
    if (navigator.vibrate) {
      navigator.vibrate([200, 100, 200])
    }
  } catch {
    // Silently fail
  }
}

// Longer ringtone pattern for important notifications (payment requests)
export function playRingtone() {
  try {
    const ctx = getAudioContext()
    const now = ctx.currentTime

    // Phone-like ring pattern: two bursts
    for (let burst = 0; burst < 2; burst++) {
      const offset = burst * 0.7
      const ringTones = [
        { freq: 940, start: offset, dur: 0.12 },
        { freq: 1175, start: offset + 0.12, dur: 0.12 },
        { freq: 940, start: offset + 0.24, dur: 0.12 },
        { freq: 1175, start: offset + 0.36, dur: 0.15 },
      ]

      ringTones.forEach(({ freq, start, dur }) => {
        const osc = ctx.createOscillator()
        const gain = ctx.createGain()
        osc.connect(gain)
        gain.connect(ctx.destination)
        osc.type = 'sine'
        osc.frequency.setValueAtTime(freq, now + start)
        gain.gain.setValueAtTime(0.35, now + start)
        gain.gain.exponentialRampToValueAtTime(0.001, now + start + dur)
        osc.start(now + start)
        osc.stop(now + start + dur + 0.02)
      })
    }

    // Vibrate pattern
    if (navigator.vibrate) {
      navigator.vibrate([300, 150, 300, 150, 300])
    }
  } catch {
    // Silently fail
  }
}
